import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

const LIMIT = 10;

function conventionImg(img, props, size = '150x') {
    if (typeof img !== 'object') {
        return undefined;
    }
    const imgSrc = `${img.s3LargeLink}`;
    return imgSrc;
}

function participantExists(participants, key, value) {
    return participants.some(participant => participant[key] === value);
}

function memberExists(members, key, value) {
    return members.some(member => member[key] === value);
}

function generateArray(X) {
    const myNewShinyArray = [...Array(parseInt(X, 10) + 1).keys()];
    myNewShinyArray.shift();
    return myNewShinyArray;
}

@observer
class CompetitionResult extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            sections: fields.get('competitionResult'),
        };
        this.mainContainer = null;
    }

    viewTags = obj => {
        if (obj.tags?.length === 0 && obj.loans?.length === 0 && !obj.ownedByOther && !obj.url && !obj.parents?.length > 0 && !obj.files?.length > 0) {
            return '';
        }
        const { userStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const tagClass = darkmode ? 'dark' : 'light';

        return (<>
            <div class='w-100 overflow-hidden'>
                <div class='box-line-tags d-flex flex-nowrap'>
                    {obj.files?.length > 0 && <>
                        <span class={`badge text-bg-light me-1 mt-1`}>
                            <i class='fa-duotone fa-file' /> <span class='font-weight-lighter'> x {obj.files.length}</span>
                        </span>
                    </>}
                    {obj.tags?.length > 0 && obj.tags.map(tag => {
                        return (<>
                            <span
                                class={`badge text-bg-${tagClass} me-1 mt-1`}
                                onClick={this.toggleTagFilter}
                                data-tag={tag.name}
                            >#{tag.name}</span>
                        </>);
                    })}
                </div>
            </div>
        </>);
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id, currentUserOnly } = props;
        const { competitionResultStore, userStore } = this.props.stores;
        const { user = {} } = userStore;
        await competitionResultStore.load({ query: {
            user: user.id,
        } });
    }

    newCompetitionResult = () => {
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        const { drawerHeightMediumLarge } = appState;
		appState.openDrawer('newCompetitionResult', {
			height: drawerHeightMediumLarge,
            callback: user => {
                this.loadAll();
            },
		}, drawerLevel + 1);
    }

    aiUploadCompetitionResult = () => {
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        const { drawerHeightMediumLarge } = appState;
		appState.openDrawer('aiUploadCompetitionResult', {
			height: drawerHeightMediumLarge,
            callback: () => {
                this.loadAll();
            },
		}, drawerLevel + 1);
    }

    editCompetitionResult = e => {
        const { id } = e.target.closest('tr').dataset;
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        const { drawerHeightMediumLarge } = appState;
		appState.openDrawer('editCompetitionResult', {
			height: drawerHeightMediumLarge,
            id,
            callback: user => {
                this.loadAll();
            },
		}, drawerLevel + 1);
    }

    setRefreshPage = () => {
        const { competitionResultStore } = this.props.stores;
        competitionResultStore.setRefreshPage(() => {
            // console.log('refresh page competitionResult list', this.props);
            this.loadAll(this.props, false, false);
        });
    }

    clearRefreshPage = () => {
        const { competitionResultStore } = this.props.stores;
        competitionResultStore.setRefreshPage(null);
    }

    componentDidMount() {
        this.loadAll();
        this.setRefreshPage();
    }

    componentWillUnmount() {
        this.clearRefreshPage();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
            this.loadAll(nextProps);
        }
    }

    render() {
        const { showAll, offset = 0 } = this.state;
        const {
            classNames = '',
            title = 'Stevner / treninger',
            children,
            todayOnly,
        } = this.props;

        const { appState, userStore, competitionResultStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { competitionResults = [] } = competitionResultStore;

        const apiServer = util.getApiServer();
        const jwtToken = util.getJwtToken();

        const totalResults = competitionResults.length;
        const numIntervals = Math.ceil(totalResults / LIMIT);
        const intervals = Array.from({ length: numIntervals }, (_, index) => index * LIMIT);

        return (<>

            <div class='d-flex flex-wrap justify-content-center align-items-center mb-3 gap-1'>
                <button
                    class='btn btn-sm btn-primary rounded-pill mt-2'
                    onClick={this.newCompetitionResult}
                >
                    <i class='fa-duotone fa-plus' /> <Text id='user.addCompetitionResult'>Add</Text>
                </button>
                <button
                    class='btn btn-sm btn-outline-primary rounded-pill mt-2'
                    onClick={this.aiUploadCompetitionResult}
                >
                    <i class='fa-duotone fa-file-pdf' /> <Text id='user.aiUploadCompetitionResult'>Upload result list (AI)</Text>
                </button>
                <a
                    class='btn btn-sm btn-success text-white rounded-pill mt-2'
                    href={`${apiServer}/api/competitionresults/download?jwtToken=${jwtToken}&offset=${offset}`}
                    target='_blank'
                >
                    <i class='fa-duotone fa-download' /> <Text id='user.download-police-form'>Download</Text>
                </a>
                {competitionResults.length > LIMIT && <>
                    <div class='mt-3 ms-2'>
                        <select
                            class={`form-control rounded-lg`}
                            onInput={linkstate(this, 'offset')}
                        >
                            <option value=''>-- Velg start --</option>
                            {intervals.map(start => (
                                <option value={start} key={start}>
                                    {start} - {Math.min(start + LIMIT, totalResults)}
                                </option>
                            ))}
                        </select>
                    </div>
                </>}
            </div>
            <div class='w-100' style='overflow-x: hidden;'>
                {competitionResults && competitionResults.length > 0 ? <>
                    {(() => {
                        // Group competitions by date, then by title+organizer
                        const groupedByDate = {};
                        competitionResults.forEach(competition => {
                            const dateKey = util.isoDate(competition.date, false, false, true);
                            if (!groupedByDate[dateKey]) {
                                groupedByDate[dateKey] = {
                                    results: [],
                                    title: competition.title,
                                    organizer: competition.organizer,
                                    place: competition.place,
                                };
                            }
                            groupedByDate[dateKey].results.push(competition);
                        });

                        // Sort dates descending (newest first)
                        const sortedDates = Object.keys(groupedByDate).sort((a, b) => new Date(b) - new Date(a));

                        // Get rank medal/emoji
                        const getRankDisplay = (rank) => {
                            if (!rank) return '';
                            const rankNum = parseInt(rank, 10);
                            if (rankNum === 1) return <><span class='me-1'>🥇</span>{rank}</>;
                            if (rankNum === 2) return <><span class='me-1'>🥈</span>{rank}</>;
                            if (rankNum === 3) return <><span class='me-1'>🥉</span>{rank}</>;
                            return rank;
                        };

                        return sortedDates.map(dateKey => {
                            const dayData = groupedByDate[dateKey];
                            const dayResults = dayData.results;
                            const firstCompetition = dayResults[0];
                            const formattedDate = util.formatDate(firstCompetition.date, {
                                weekday: 'long',
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                                locale: 'nb-NO'
                            });

                            return (<>
                                {/* Date header */}
                                <div
                                    class='d-flex align-items-center mt-4 mb-2 pb-2'
                                    style='border-bottom: 2px solid var(--bs-primary); opacity: 0.9;'
                                >
                                    <i class='fa-solid fa-calendar-day me-2 text-primary' />
                                    <span style='font-weight: 600; font-size: 1rem; text-transform: capitalize;'>
                                        {formattedDate}
                                    </span>
                                    <span class='ms-2 badge bg-secondary rounded-pill' style='font-size: 0.7rem;'>
                                        {dayResults.length} {dayResults.length === 1 ? 'resultat' : 'resultater'}
                                    </span>
                                </div>

                                {/* Competition card for the day */}
                                <div class={`mb-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-light'}`} style='overflow: hidden;'>
                                    {/* Competition header - shown once */}
                                    <div
                                        class='px-3 py-2'
                                        style={`background: ${darkmode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'}; border-bottom: 1px solid ${darkmode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'};`}
                                    >
                                        <div class='d-flex align-items-center'>
                                            <i class='fa-solid fa-trophy me-2 text-warning' style='font-size: 0.9rem;' />
                                            <span style='font-weight: 500;'>{dayData.title || 'Konkurranse'}</span>
                                        </div>
                                        <div class='d-flex align-items-center mt-1 ps-4'>
                                            {dayData.organizer && (
                                                <span class='text-muted' style='font-size: 0.8rem;'>
                                                    <i class='fa-solid fa-building me-1' />
                                                    {dayData.organizer}
                                                </span>
                                            )}
                                            {dayData.place && dayData.place !== dayData.organizer && (
                                                <span class='text-muted ms-3' style='font-size: 0.8rem;'>
                                                    <i class='fa-solid fa-location-dot me-1' />
                                                    {dayData.place}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {/* Individual results/stages */}
                                    {dayResults.map((competition, idx) => (
                                        <div
                                            class='px-3 py-2'
                                            style={`cursor: pointer; ${idx > 0 ? `border-top: 1px solid ${darkmode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'};` : ''}`}
                                            data-id={competition.id}
                                            onClick={this.editCompetitionResult}
                                        >
                                            <div class='d-flex align-items-center justify-content-between flex-wrap gap-2'>
                                                {/* Left side: ID, Program, Class */}
                                                <div class='d-flex align-items-center flex-wrap gap-2'>
                                                    {competition.competitionId && (
                                                        <span class='text-muted' style='font-size: 0.75rem;'>
                                                            #{competition.competitionId}
                                                        </span>
                                                    )}
                                                    {competition.program && (
                                                        <span class={`badge ${darkmode ? 'bg-dark' : 'bg-white border'}`} style='font-size: 0.8rem; font-weight: 500;'>
                                                            {competition.program}
                                                        </span>
                                                    )}
                                                    {competition.class && (
                                                        <span class='text-muted' style='font-size: 0.85rem;'>
                                                            {competition.class}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Right side: Rank, Score, Promotion */}
                                                <div class='d-flex align-items-center gap-3'>
                                                    <div class='text-center' style='min-width: 50px;'>
                                                        <small class='text-muted d-block' style='font-size: 0.6rem; text-transform: uppercase;'>Plass</small>
                                                        <span style='font-weight: 600; font-size: 0.95rem;'>
                                                            {competition.rank ? getRankDisplay(competition.rank) : <span class='text-muted'>-</span>}
                                                        </span>
                                                    </div>
                                                    <div class='text-center' style='min-width: 50px;'>
                                                        <small class='text-muted d-block' style='font-size: 0.6rem; text-transform: uppercase;'>Poeng</small>
                                                        <span style={`font-weight: 700; font-size: 1rem; ${competition.score ? 'color: var(--bs-success);' : ''}`}>
                                                            {competition.score || <span class='text-muted'>-</span>}
                                                        </span>
                                                    </div>
                                                    <div class='text-center' style='min-width: 60px;'>
                                                        <small class='text-muted d-block' style='font-size: 0.6rem; text-transform: uppercase;'>Opprykk</small>
                                                        {competition.promotionClass ? (
                                                            <span class='badge bg-success' style='font-size: 0.75rem;'>
                                                                → {competition.promotionClass}
                                                            </span>
                                                        ) : (
                                                            <span class='text-muted' style='font-size: 0.85rem;'>-</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>);
                        });
                    })()}
                </> : (
                    <div class='text-center text-muted py-5'>
                        <i class='fa-solid fa-trophy fa-3x mb-3' style='opacity: 0.2;' />
                        <p><Text id='competitionResult.no-results'>No competition results yet</Text></p>
                    </div>
                )}
            </div>
        </>);
    }
}

export default CompetitionResult;
